import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import lang from '@/lang'
import config from '@/config'
import ButtonIconSquare, { VARIANTS } from '@/modules/base/components/buttons/icon-square/button-icon-square'
import LetterPaperPreview from '@/modules/letter-paper-settings/letter-paper/edit/letter-paper-preview'
import Drawer from '@mui/material/Drawer'
import IconClose from '@assets/images/icons/v2/close.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import theme from '@/theme'

const useStyles = makeStyles((theme) => ({
  drawerRoot: {
    zIndex: 1300,
  },
  drawer: {
    display: 'flex',
    width: 'calc(80vw - 350px)',
    minWidth: 500,
    flexDirection: 'row',
  },
  close: {
    cursor: 'pointer',
    position: 'absolute',
    right: 20,
    top: 34,
    zIndex: 1,
  },
  onboardingButton: {
    paddingTop: 10,
    display: 'flex',
    justifyContent: 'end',
    cursor: 'pointer',
    color: theme.primary,
  },
}))

const LetterPaperLayoutPreview = (props) => {
  const { layoutId, layoutItems, isOnboardingTester = false } = props

  const classes = useStyles()
  const [url, setUrl] = useState()
  const [open, setOpen] = useState(false)
  const { defaultId } = useSelector(store => store.settings.letterPaper)

  useEffect(() => {
    const layoutName = layoutItems?.filter(({ id }) => id === layoutId).map(items => items.name).toString()
    defaultId && setUrl(`${config.resourceHost}setting/letterPaper/pages/${defaultId}/file?preview=true&layout=${layoutName}`)
  }, [layoutId, defaultId])

  const onEditClickHandle = () => {
    setOpen(true)
  }

  const onCloseHandle = () => {
    setOpen(false)
  }

  return (
    <div>
      {isOnboardingTester
        ? <div onClick={onEditClickHandle} className={classes.onboardingButton}>{lang.settings.letterPaperSettings.letterPaperLayoutPreview}</div>
        : <ButtonIconSquare label={lang.settings.letterPaperSettings.letterPaperLayoutPreview} onClick={onEditClickHandle} variant={VARIANTS.outline} dataQsId='settings-letter-paper-layout-preview'></ButtonIconSquare>
      }
      <Drawer
        classes={{ root: classes.drawerRoot, paper: classes.drawer }}
        anchor="right"
        transitionDuration={400}
        open={open}
        onClose={onCloseHandle}
        ModalProps={{
          disableEscapeKeyDown: true,
        }}>
        <SVGIcon onClick={onCloseHandle} className={classes.close} svg={IconClose} width="16px" height="16px" fill={theme.iconFillColor} />
        <LetterPaperPreview url={url} />
      </Drawer>
    </div>
  )
}

LetterPaperLayoutPreview.propTypes = {
  layoutItems: PropTypes.object,
  layoutId: PropTypes.string,
  isOnboardingTester: PropTypes.bool,
}

export default LetterPaperLayoutPreview
